module.exports = __webpack_public_path__ + "static/media/rebirth_15.43e75be1.jpg";